// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__WICW3","label":"CheckBox_label__MZh11","switch":"CheckBox_switch__2Hul2","slider":"CheckBox_slider__9BzAj"};